import React from "react";
import { Prompt } from "react-router";
import WarningDialog from "./WarningDialog";

interface RouteLeavingGuardProps {
  when?: boolean | undefined;
  navigate: (path: string) => void;
  shouldBlockNavigation: (location: Location) => boolean;
}

function RouteLeavingGuard(props: RouteLeavingGuardProps) {
  const { when, navigate, shouldBlockNavigation } = props;

  const [modalVisible, setModalVisible] = React.useState(false);
  const [lastLocation, setLastLocation] = React.useState<Location | null>(null);
  const [confirmedNavigation, setConfirmedNavigation] = React.useState(false);

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleBlockedNavigation = (nextLocation: Location): boolean => {
    if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
      setModalVisible(true);
      setLastLocation(nextLocation);
      return false;
    }

    return true;
  };

  React.useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      // Navigate to the previous blocked location with your navigate function
      navigate(lastLocation.pathname);
    }
  }, [confirmedNavigation, lastLocation, navigate]);

  const handleConfirmNavigationClick = () => {
    setModalVisible(false);
    setConfirmedNavigation(true);
  };

  return (
    <>
      <Prompt
        when={when}
        message={(location: any, _) => handleBlockedNavigation(location)}
      />

      <WarningDialog
        isOpen={modalVisible}
        confirmText="Discard Changes"
        contentText="You have unsaved changes. Are you sure you want to leave this page without saving?"
        titleText="Continue without saving?"
        onConfirmHandler={handleConfirmNavigationClick}
        onCloseHandler={closeModal}
      />
    </>
  );
}

export default RouteLeavingGuard;
